/** Textos em português simples para os valores do catálogo de agentes nocivos. */
import type { HazardousAgentChangeAction } from '../../services/hazardousAgentService';

export const DEGREE_LABELS: Record<string, string> = {
  MINIMO: 'Mínimo',
  MEDIO: 'Médio',
  MAXIMO: 'Máximo',
};

export const STATUS_LABELS: Record<string, string> = {
  ACTIVE: 'Ativo',
  INACTIVE: 'Inativo',
};

export const FIELD_LABELS: Record<string, string> = {
  unhealthyDegree: 'Grau de insalubridade',
  nr15Annex: 'Anexo da NR-15',
  hygieneStandards: 'Norma de higiene',
  status: 'Situação',
  limit: 'Opção de limite',
  toleranceLimit: 'Valor do limite',
  measurementUnit: 'Unidade',
  source: 'Norma de origem',
};

export const ACTION_LABELS: Record<HazardousAgentChangeAction, string> = {
  CREATE: 'Adicionou',
  UPDATE: 'Alterou',
  DELETE: 'Removeu',
  INACTIVATE: 'Inativou',
  REACTIVATE: 'Reativou',
};

/** Valor guardado no histórico, escrito como a pessoa lê na tela. */
export function readableValue(field: string, value: string | null): string {
  if (value === null || value === '') return '—';
  if (field === 'unhealthyDegree') return DEGREE_LABELS[value] ?? value;
  if (field === 'status') return STATUS_LABELS[value] ?? value;
  return value;
}
